import ThemeContext from "components/app/Context";
import Scroller from "components/common/Scroller/InfiniteScroller";
import Item from "components/features/MyPlans/item";
import { useContext } from "react";
import { useAppSelector } from "redux/hooks";
import NoPropertyPlansBanner from "../IndividualProperty/NoPropertyPlansBanner";
import TableHeader from "../MyPlans/TableHeader";

interface Prop {
  label?: string;
  fetchMore: () => void;
}

const PropertyPlansList = (props: Prop) => {
  const { label = "", fetchMore } = props;
  const { totalList, plansList: userplans } = useAppSelector((state) => state.aboveProperty.planProgress);
  const { isMobileScreen } = useContext(ThemeContext);
  const abovePropertyLoader = useAppSelector((state) => state.aboveProperty.abovePropertyLoader);
  return (
    <>
      {userplans?.length ? (
        <>
          {!isMobileScreen && <TableHeader />}
          <Scroller dataLength={userplans?.length} loadMore={fetchMore} totalList={totalList} label={label}>
            {userplans?.map((plan: any) => {
              return <Item key={plan.id} plan={plan} />;
            })}
          </Scroller>
        </>
      ) : (
        !abovePropertyLoader && <NoPropertyPlansBanner />
      )}
    </>
  );
};

export default PropertyPlansList;
